import { Flex } from '@chakra-ui/react';
import ParameterValue from './ParameterValue';

const ParameterValues = (props: any) => {
  const { model, parameter, preload, paramKey } = props;

  if (!model) return null;

  const checkConditions = (key: string) => {
    if (key === 'onConditions') {
      return !parameter.conditional;
    }
    if (key === 'values' && parameter.inputType === 'text') {
      return false;
    }

    if (key === 'isPreloaded' && !preload) {
      return false;
    }

    if (key === 'isPreloaded' && preload && parameter.inputType !== 'select') {
      return false;
    }

    return true;
  };

  return (
    <>
      {Object.entries(model)
        .filter(([key]) => checkConditions(key))
        .map(([key, value]: any) => {
          const item = parameter[key];

          return value.inputType === 'expression' || key === 'values' ? (
            <Flex
              sx={{
                flex: 1,
                flexDir: 'column',
                justifyContent: 'flex-start',
                bgColor: 'base2Colour.500',
                p: 2.5,
                fontSize: 'sm',
                color: 'base2FontColour.500',
              }}
              key={`${paramKey}${key}`}
            >
              <Flex flex={1} textTransform="uppercase">
                {value.displayName}
              </Flex>
              <ParameterValue itemModel={value} item={item} modelKey={key} {...props} />
            </Flex>
          ) : (
            <Flex
              sx={{
                flex: 1,
                flexDir: 'row',
                justifyContent: 'flex-start',
                bgColor: 'base2Colour.500',
                p: 5,
                alignItems: 'center',
                fontSize: 'sm',
                color: 'base2FontColour.500',
              }}
              key={`${paramKey}${key}`}
            >
              <Flex flex={1} textTransform="uppercase">
                {value.displayName}
              </Flex>
              <ParameterValue itemModel={value} item={item} modelKey={key} {...props} />
            </Flex>
          );
        })}
    </>
  );
};

export default ParameterValues;
